import { client } from './index';
import { ITenantConfig } from '../domains/tenant-config';
import { ICountry, IRegion } from '../domains/tenant.domain';

const API = '/tenants/';

export const getConfig = (tenantId: string | null): Promise<ITenantConfig> =>
  client.get(`${API}${tenantId}`).then(response => response.data);

export const getCountries = (tenantId: string, language: string): Promise<ICountry[]> =>
  client.get(`${API}${tenantId}/countries?language=${language}`).then(response => response.data);

export const getRegions = (tenantId: string, countryCode: string, language: string): Promise<IRegion[]> =>
  client.get(`${API}${tenantId}/countries/${countryCode}/regions?language=${language}`).then(response => response.data);

export const getCities = (countryCode: string, regionCode: string): Promise<string[]> =>
  client.get(`/countries/${countryCode}/regions/${regionCode}/cities`).then(response => response.data);
